import { apiConstants } from '../../apiConstant'
import { formDataCommonFunction, formDataCommonFunctionPut, serviceCall } from '../../serviceCall'

const updateTicketTicketThreadApi = (data, callback, errorCallBack,params) => {
  
  return async (dispatch) => {
 
    formDataCommonFunctionPut(data,apiConstants.TICKET.UPDATE_TICKET_THREAD_BY_ID)
      .then((response) => {
        callback && callback(response)
      })
      .catch((error) => {
        errorCallBack && errorCallBack(error.response)
      })
  }
}

export default updateTicketTicketThreadApi;